<template>
  <div>
    <v-row class="mb-0 mt-0 pt-0 pb-0">
      <v-col class="d-flex col-12 mb-0 mt-0 pt-0 pb-0">
        <v-col cols="12" md="4" class="mb-0 mt-0 pt-0 pb-0">
          <!--Cihaz Adı:-->
          <v-text-field
            label="Cihaz Adı:"
            v-model="formData.deviceName"
            required
            outlined
            dense
            hide-details
          />
        </v-col>

        <v-col cols="12" md="4" class="mb-0 mt-0 pt-0 pb-0">
          <!--Üretici firma:-->
          <v-text-field
            label="Üretici firma:"
            v-model="formData.DeviceManufacture"
            required
            outlined
            disabled
            dense
            hide-details
          />
        </v-col>

        <v-col cols="12" md="4" class="mb-0 mt-0 pt-0 pb-0">
          <!--Cihaz Seri Numarası:-->
          <v-text-field
            label="Cihaz Seri Numarası:"
            v-model="formData.serial"
            outlined
            dense
            hide-details
          />
        </v-col>
      </v-col>
    </v-row>

    <v-row class="mb-0 mt-0 pt-1 pb-0">
      <v-col class="d-flex col-12 mb-0 mt-0">
        <!--  <v-col cols="12" md="3" class="mb-0 mt-0 pt-0 pb-0">
         
          <v-text-field
            label="Model:"
            v-model="formData.Model"
            required
            outlined
            disabled
            dense
            hide-details
          />
        </v-col> -->
        <v-col cols="12" md="4" class="mb-0 mt-0 pt-0 pb-0">
          <!--Ip adres:-->
          <v-text-field
            label="Ip adres:"
            v-model="formData.ipAddress"
            :counter="10"
            required
            outlined
            dense
            hide-details
          />
        </v-col>

        <v-col cols="12" md="4" class="mb-0 mt-0 pt-0 pb-0">
          <!--Port:-->
          <v-text-field
            label="Port:"
            v-model="formData.port"
            required
            outlined
            dense
            hide-details
          />
        </v-col>

        <v-col cols="12" md="4" class="mb-0 mt-0 pt-0 pb-0">
          <!--Zaman Aralığı:-->
          <v-select
            label="Zaman Aralığı:"
            v-model="formData.timeInterval"
            autofocus
            outlined
            :items="timeIntervalList"
            dense
            hide-details
          />
        </v-col>
      </v-col>
    </v-row>

    <v-row class="mb-0 mt-0 pt-0 pb-0">
      <v-col class="d-flex col-12 mb-0 mt-0">
        <v-col cols="12" md="4" class="mb-0 mt-0 pt-0 pb-0">
          <!--Datalogger Kullanıcı adı:-->
          <v-text-field
            label=" Datalogger Kullanıcı adı:"
            v-model="formData.LoggerName"
            required
            outlined
            dense
            hide-details
          />
        </v-col>
        <v-col cols="12" md="4" class="mb-0 mt-0 pt-0 pb-0">
          <!--Datalogger Şifre:-->
          <v-text-field
            label=" Datalogger Şifre:"
            v-model="formData.LoggerPass"
            required
            outlined
            dense
            hide-details
          />
        </v-col>
        <v-col cols="12" md="4" class="mb-0 mt-0 pt-0 pb-0">
          <!--Tarih formatı:-->
          <v-select
            label="Tarih formatı:"
            v-model="formData.dateFormaterModel"
            autofocus
            outlined
            :items="dateFormaterList"
            dense
            hide-details
          />
        </v-col>
      </v-col>
    </v-row>

    <v-row class="mb-0 mt-0 pt-0 pb-0">
      <v-col class="d-flex col-12 mb-0 mt-0">
        <v-col cols="12" md="3" class="mb-0 mt-0 pt-0 pb-0">
          <!--Ftp User:-->
          <v-text-field
            v-model="formData.ftpuser"
            required
            label="Ftp User:"
            outlined
            dense
            hide-details
          />
        </v-col>
        <v-col cols="12" md="3" class="mb-0 mt-0 pt-0 pb-0">
          <!--Ftp Şifre:-->
          <v-text-field
            label="Ftp Şifre:"
            v-model="formData.ftppass"
            required
            outlined
            dense
            hide-details
          />
        </v-col>
        <v-col cols="12" md="3" class="mb-0 mt-0 pt-0 pb-0">
          <!--Ftp Dosya:-->
          <v-text-field
            label="Ftp Dosya:"
            v-model="formData.ftpfile"
            required
            outlined
            dense
            hide-details
          />
        </v-col>
        <v-col cols="12" md="3" class="mb-0 mt-0 pt-0 pb-0">
          <!--Ftp Dosya adı:-->
          <v-select
            label=" Ftp Dosya adı:"
            v-model="formData.ftpfilename"
            autofocus
            outlined
            :items="fileFormaterList"
            dense
            hide-details
          />
        </v-col>
      </v-col>
    </v-row>

    <v-row class="mb-0 ml-4 mt-0 pt-0 pb-0">
      <v-col cols="12" md="12" class="text-right">
        <v-btn color="primary" @click="saveForm" dense outlined> Cihazı Kaydet </v-btn>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  props: ["deviceData", "santralData"],
  data: () => ({
    formData: {
      deviceName: "",
      ipAddress: "",
      port: "",
      serial: "",
      dateFormaterModel: "",
      model: "",
      status: "Active",
      timeInterval: null,
      url: "",
      ftpfile: "/",
      ftppass: "",
      ftpuser: "",
      ftpfilename: ""
    },
    timeIntervalList: [],
    dateFormaterList: [
      { text: "Y-m-d H:M:S", value: "%Y-%m-%d %H:%M:%S" },
      { text: "d-m-Y H:M:S", value: "%m-%m-%Y %H:%M:%S" }
    ],
    fileFormaterList: [
      { text: "YmdH", value: "YmdH" },
      { text: "dmYH", value: "dmYH" }
    ]
  }),
  watch: {
    deviceData() {
      this.setForm();
    }
  },
  mounted() {
    this.setForm();
  },
  methods: {
    setForm() {
      console.log(this.deviceData);
      this.formData.timeInterval = this.deviceData.UploadCycleTime;
      this.formData.DeviceModel = this.deviceData.DeviceModel;
      this.formData.model = this.deviceData.Model;
      this.formData.ftpfilename = this.deviceData.ftpfilename;
      this.formData.DeviceManufacture = this.deviceData.DeviceManufacture;
      this.formData.ftpfile = this.deviceData.ftpfile;
      this.formData.ftppass = this.deviceData.ftppass;
      this.formData.ftpuser = this.deviceData.ftpuser;
      this.formData.ftpDateType = this.deviceData.ftpDateType;
      this.formData = { ...this.formData, ...this.santralData };

      // ftpfile: '/i2utyy',
      // ftppass: 'i2utyy',
      // ftpuser: 'admin_i2utyy',
      // eslint-disable-next-line radix
      const cycle = parseInt(this.deviceData.timeInterval);
      const timeIntervalList = [];
      for (let i = cycle; i <= 60; i += cycle) {
        timeIntervalList.push(i);
      }

      this.timeIntervalList = timeIntervalList;
    },

    saveForm() {
      console.log(this.formData);
      this.$emit("savedataloger", this.formData);
    }
  }
};
</script>

<style></style>
